import React from 'react';
import { Spinner } from '../components/spinner/Spinner';
import { IonText } from '@ionic/react';

export const PendingAdvisory: React.FC<{header: string, children: React.ReactNode}> = ({ header, children }) => {
    return (
        <div style={{ padding: 8, display: 'flex', gap: 8, alignItems: 'flex-start', justifyContent: 'space-between' }}>
            <div>
                <h6 data-advisory-title style={{ margin: 0 }}>{header}</h6>
                <IonText color="medium" style={{fontSize: 12}}>{children}</IonText>
            </div>
            <div style={{ marginRight: 4, marginTop: 4 }}>
                <Spinner size="small" />
            </div>
        </div>
    );
};
